import styleFn, {compose} from '../util'

const textAlign = styleFn({
  propName: 'textAlign'
})

const lineHeight = styleFn({
  propName: 'lineHeight'
})

const fontWeight = styleFn({
  propName: 'fontWeight'
})

const fontSize = styleFn({
  propName: 'fontSize',
  systemProp: 'fsizes'
})

const fontStyle = styleFn({
  propName: 'fontStyle'
})

export default compose(
  textAlign,
  fontStyle,
  lineHeight,
  fontWeight,
  fontSize
)
